<template>
    <el-form
      :model="form"
      :rules="rules"
      ref="form"
      label-position="left"
      label-width="0px"
      v-loading="loading"
    >
      <el-form-item prop="name">
        <el-input
          type="text"
          v-model="form.name"
          autocomplete="off"
          placeholder="主材用量指标名称"
        ></el-input>
      </el-form-item>
      <el-form-item prop="perUnitUsage">
        <el-input
          type="text"
          v-model="form.perUnitUsage"
          autocomplete="off"
          placeholder="主材单方用量"
        ></el-input>
      </el-form-item>
      <el-form-item prop="unit">
        <el-input
          type="text"
          v-model="form.unit"
          autocomplete="off"
          placeholder="单位"
        ></el-input>
      </el-form-item>
      <el-form-item style="width: 100%" v-if="type == 'add'">
        <el-button
          type="primary"
          style="width: 100%;border: none"
          v-on:click="add"
          >新建</el-button
        >
      </el-form-item>
      <el-form-item style="width: 100%" v-if="type == 'edit'">
        <el-button
          type="primary"
          style="width: 100%;border: none"
          v-on:click="edit"
          >更新</el-button
        >
      </el-form-item>
    </el-form>
</template>
<script>
export default {
  name: 'MajorMaterialUsageForm',

  props: {
    type: {
      type: String,
      default: ''
    },
    rules: {},
    form: {
      name: '',
      perUnitUsage: '',
      unit: ''
    }
  },

  data () {
    return {
      loading: false
    }
  },

  methods: {
    add () {
      var _this = this
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$data.loading = true
          this.postRequest('/major_materials_usage/add', _this.form)
            .then(resp => {
              _this.$data.loading = false
              if (resp && resp.code === 200) {
                _this.$message.success({ message: '新建成功' })
                _this.$router.replace('/major_materials_usage')
              }
            })
        }
      })
    },

    edit () {
      var _this = this
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$data.loading = true
          this.postRequest('/major_materials_usage/edit', _this.form)
            .then(resp => {
              _this.$data.loading = false
              if (resp && resp.code === 200) {
                _this.$message.success({ message: '更新成功' })
                // _this.$router.replace('/major_materials_usage')
              }
            })
        }
      })
    }
  }
}
</script>
<style></style>
